import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonService } from '../services/common.service';
import { Observable } from 'rxjs';
import { LoaderService } from 'src/app/core/services/loader.service';
import { ThemePalette } from '@angular/material/core';
import { ProgressSpinnerMode, MatProgressSpinner } from '@angular/material/progress-spinner';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'app-spinner',
    templateUrl: './spinner.component.html',
    styleUrls: ['./spinner.component.scss'],
    imports: [MatProgressSpinner, AsyncPipe]
})
export class SpinnerComponent implements OnInit, OnDestroy {

  time: number;
  subcriber: any;
  public loading$: Observable<any>;
  color: ThemePalette = 'primary';
  mode: ProgressSpinnerMode = 'indeterminate';
  value = 75;
  constructor(private _cs: CommonService, private loaderService: LoaderService) { }

  ngOnInit() {
    this.loading$ = this.loaderService.isLoading;
    this.subcriber =  this._cs.apiTime.subscribe(value => this.time = value);
  }

  ngOnDestroy() {
    this.subcriber.unsubscribe();
  }


}
